import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30ec71e4")

_pushScopeId("data-v-30ec71e4")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "Loading" }, [
  /*#__PURE__*/_createVNode("div", { class: "Loading__content" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.loading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2
      ]))
    : _createCommentVNode("", true)
})